import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './containers/app';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import configureStore from 'store/configureStore';
import './global.css';
import { EdgeOptionsSetup } from 'common/edge-filter-cards/options';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const appInsightsConnectionString = process.env.REACT_APP_APP_INSIGHTS_CONNECTION_STRING;
const isValidAppInsightsConnectionString = (connectionString) =>
  /(^|;)InstrumentationKey=[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(;|$)/.test(
    connectionString || '',
  );

if (isValidAppInsightsConnectionString(appInsightsConnectionString)) {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: appInsightsConnectionString,
      enableAutoRouteTracking: true,
      excludeRequestFromAutoTrackingPatterns: [
        /\/graph(\?|$)/i,
        /\/api\/token(\?|$)/i,
      ],
    },
  });
  appInsights.loadAppInsights();
}

// Environment-specific favicon: production uses Foundation Blue, dev/QA keep orange
if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
  const link = document.querySelector("link[rel='icon']");
  if (link) link.href = '/icon-education-blue.svg';
}

const store = configureStore();
EdgeOptionsSetup();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
